window.osj = {
	macyInstances: [],
	calendar: {
		eventsCount: 0,
		currentEventIds: [],
	},
	islider: false,
	textListIndex: 0,
	texts: [],
	textsLoading: false,
};

const appHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

const hamburger_width = () => {
	const hamburger = document.getElementById("bigmenu_hamburger");
	hamburger.style.width = "";
	hamburger.style.width = hamburger.offsetWidth + "px";
};
window.addEventListener("resize", hamburger_width);
hamburger_width();

gsap.registerPlugin(ScrollTrigger);

const initSmoothScrolling = () => {
	let lenis_options = {
		orientation: "vertical",
		lerp: 0.2, // Lower values create a smoother scroll effect
		smoothWheel: true, // Enables smooth scrolling for mouse wheel events
	};

	// Instantiate the Lenis object with specified properties
	window.lenis_scroll = new Lenis(lenis_options);

	// Update ScrollTrigger each time the user scrolls
	window.lenis_scroll.on("scroll", ({ direction }) => {
		ScrollTrigger.update();
	});

	// Define a function to run at each animation frame
	const scrollFn = (time) => {
		window.lenis_scroll.raf(time); // Run Lenis' requestAnimationFrame method
		requestAnimationFrame(scrollFn); // Recursively call scrollFn on each frame
	};
	// Start the animation frame loop
	requestAnimationFrame(scrollFn);
};

initSmoothScrolling();

const generalAnimations = gsap.utils.toArray(".generalAnim");

generalAnimations.forEach((box, i) => {
	const anim = gsap.fromTo(
		box,
		{ autoAlpha: 0, y: 100 },
		{ duration: 0.75, autoAlpha: 1, y: 0 },
	);
	ScrollTrigger.create({
		trigger: box,
		start: "25% bottom",
		animation: anim,
		toggleActions: "play none none none",
		once: true,
	});
});

const splitTextAnimate = gsap.utils.toArray(".split-text-animate");

splitTextAnimate.forEach(function (element) {
	const SplitTextTimeLine = gsap.timeline();

	const sectionTitleSplit = new SplitType(element, {
		types: "words, chars",
	});
	const chars = sectionTitleSplit.chars;

	SplitTextTimeLine.from(chars, {
		duration: 1.8,
		opacity: 0,
		y: 75,
		ease: "ease.out",
		stagger: 0.05,
		scrollTrigger: {
			trigger: element,
			start: "top 90%",
			end: "bottom center",
			scrub: true,
		},
	});
});

[...document.querySelectorAll(".mod_blocs .cols-2")].forEach((el, i) => {
	window.osj.macyInstances[i] = Macy({
		container: el,
		trueOrder: true,
		waitForImages: false,
		cancelLegacy: true,
		margin: {
			x: 50,
			y: 50,
		},
		columns: 2,
		breakAt: {
			760: {
				columns: 1,
			},
			1000: {
				margin: {
					x: 30,
					y: 20,
				},
				columns: 2,
			},
		},
	});

	//Bug fix to make it work for some reason
	setTimeout(function () {
		window.osj.macyInstances[i].reInit();
		el.classList.add("loaded");
	}, 250);
});

events_calendar();

document.addEventListener("DOMContentLoaded", function (event) {
	[...document.querySelectorAll(".results")].forEach((el, i) => {
		el.setAttribute("data-lenis-prevent", "");
	});
	const footer_products = document.querySelector(".glide-products");
	if (footer_products) {
		new Glide(footer_products, {
			type: "slider",
			keyboard: false,
			perView: 3,
			gap: 20,
			breakpoints: {
				1020: {
					perView: 2,
				},
				600: {
					perView: 1,
				},
			},
		}).mount();

		[...document.querySelectorAll(".glide-products .product")].forEach(
			(el, i) => {
				el.addEventListener("click", (event) => {
					window.location.href = event.currentTarget.dataset.link;
				});
			},
		);
	}

	[...document.querySelectorAll(".glide.glide-posts")].forEach((el, i) => {
		let slider = new Glide(el, {
			type: "slider",
			keyboard: false,
			perView: 3,
			rewind: false,
			gap: 60,
			bound: true,
			peek: { before: 0, after: 50 },
			breakpoints: {
				1020: {
					perView: 2,
					gap: 30,
				},
				600: {
					perView: 1,
					gap: 20,
				},
			},
		});

		slider.on("mount.after", function (event) {
			slider.selector.classList.add("loaded");
		});

		/*	slider.on("move.after", function (data) {
			if (data.movement > 0) {
				slider.selector.classList.add("page-2");
			} else {
				slider.selector.classList.remove("page-2");
			}
		});*/

		slider.mount();

		[...el.querySelectorAll(".post_wrap")].forEach((item, i) => {
			item.addEventListener("click", (event) => {
				window.location.href = event.currentTarget.dataset.link;
			});
		});
	});

	[...document.querySelectorAll(".glide.glide-rows")].forEach((el, i) => {
		new Glide(el, {
			type: "slider",
			keyboard: false,
			perView: 1,
			rewind: true,
			gap: 30,
			autoHeight: true,
		}).mount({
			GlideAutoHeight: GlideAutoHeight,
		});
	});

	[
		...document.querySelectorAll(".glide.glide-carousel-items-menu-image"),
	].forEach((el, i) => {
		let slider = new Glide(el, {
			type: "slider",
			keyboard: false,
			perView: 1,
			rewind: true,
			gap: 30,
		});

		slider.on("mount.after", function (event) {
			slider.selector.classList.add("loaded");
		});

		slider.mount();
	});

	[...document.querySelectorAll("[data-open-mobile-map]")].forEach(
		(el, i) => {
			el.addEventListener("click", () => {
				document.body.classList.toggle("openMobileMap");
			});
		},
	);

	[...document.querySelectorAll(".glide.glide-carousel-i")].forEach(
		(el, i) => {
			(window.osj.islider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 1,
				rewind: false,
				animationDuration: 0,
				gap: 0,
				autoHeight: true,
				touchAngle: 0,
			})),
				(sliderParent = document.getElementById("i-wrap"));

			window.osj.islider.on("mount.after", function (event) {
				window.osj.islider.selector.classList.add("loaded");
			});

			window.osj.islider.on("run.after", function (event) {
				[...sliderParent.querySelectorAll(".item_nav")].forEach(
					(el, i) => {
						let current = window.osj.islider.index;
						el.classList.remove("active");
						if (el.dataset.index == current) {
							el.classList.add("active");
						}
					},
				);
			});

			window.osj.islider.mount({
				GlideAutoHeight: GlideAutoHeight,
			});
		},
	);

	[...document.querySelectorAll("#i-wrap .item_nav")].forEach((el, i) => {
		el.addEventListener("click", (e) => {
			let current = e.currentTarget;
			window.osj.islider.go("=" + current.dataset.index);
			document.body.classList.remove("openMobileMap");
		});
	});

	[...document.querySelectorAll(".glide.glide-mod-scroll")].forEach(
		(el, i) => {
			let slider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 1,
				rewind: true,
				gap: 30,
			});

			slider.on("mount.after", function (event) {
				slider.selector.classList.add("loaded");
			});

			slider.mount();
		},
	);

	[...document.querySelectorAll(".glide.glide-mod-carousel")].forEach(
		(el, i) => {
			let slider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 2.15,
				rewind: true,
				gap: 60,
				bound: true,
				breakpoints: {
					1020: {
						perView: 2.15,
						gap: 30,
					},
					600: {
						perView: 1.15,
						gap: 20,
					},
				},
			});

			slider.on("mount.after", function (event) {
				slider.selector.classList.add("loaded");
			});

			slider.mount();
		},
	);

	[...document.querySelectorAll(".glide.glide-mod-carousel-images")].forEach(
		(el, i) => {
			let slider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 4.25,
				rewind: true,
				gap: 60,
				bound: true,
				touchAngle: 0,
				breakpoints: {
					1020: {
						perView: 3.15,
						gap: 30,
					},
					600: {
						perView: 1.15,
						gap: 20,
					},
				},
			});

			slider.on("mount.after", function (event) {
				slider.selector.classList.add("loaded");
			});

			slider.mount();
		},
	);

	[...document.querySelectorAll(".glide.glide-mod-carousel-scroll")].forEach(
		(el, i) => {
			let slider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 3.15,
				rewind: true,
				gap: 60,
				bound: true,
				breakpoints: {
					1200: {
						perView: 2.15,
						gap: 30,
					},
					1020: {
						perView: 2.15,
						gap: 30,
					},
					600: {
						perView: 1.15,
						gap: 20,
					},
				},
			});

			slider.on("mount.after", function (event) {
				slider.selector.classList.add("loaded");
			});

			slider.mount();
		},
	);

	[...document.querySelectorAll(".glide.glide-mod-carousel-text")].forEach(
		(el, i) => {
			let slider = new Glide(el, {
				type: "slider",
				keyboard: false,
				perView: 2.65,
				rewind: true,
				gap: 60,
				breakpoints: {
					1200: {
						perView: 1.65,
						gap: 30,
					},
					1020: {
						perView: 1.25,
						gap: 30,
					},
					600: {
						perView: 1,
						gap: 20,
					},
				},
			});

			slider.on("mount.after", function (event) {
				slider.selector.classList.add("loaded");
			});

			slider.mount();
		},
	);

	[...document.querySelectorAll(".glide.glide-popup")].forEach((el, i) => {
		let slider = new Glide(el, {
			type: "slider",
			keyboard: false,
			perView: 1,
			rewind: true,
			gap: 30,
		});

		slider.on("mount.after", function (event) {
			slider.selector.classList.add("loaded");
		});

		slider.mount();
	});

	[
		...document.querySelectorAll(".mod_carousel_image_menu .menu_items"),
	].forEach((el, i) => {
		let image_bgs = el.querySelector(".image_bgs"),
			the_menu = el.querySelector(".the_menu");

		[...the_menu.querySelectorAll("li")].forEach((el, i) => {
			el.addEventListener("mouseenter", (event) => {
				let image = event.target.dataset.id;
				image_bgs.querySelector("." + image).classList.add("active");
			});
			el.addEventListener("mouseleave", (event) => {
				let image = event.target.dataset.id;
				image_bgs.querySelector("." + image).classList.remove("active");
			});
		});
	});

	if (document.querySelectorAll(".mod_standard_header .gallery")) {
		new SimpleLightbox(".mod_standard_header .gallery a", {
			overlayOpacity: 0.95,
			fileExt: "png|jpg|jpeg|gif|webp",
			animationSlide: false,
		});
	}

	[...document.querySelectorAll(".mod_blocs .gallery")].forEach((el, i) => {
		new SimpleLightbox(el.querySelectorAll("a"), {
			overlayOpacity: 0.95,
			fileExt: "png|jpg|jpeg|gif|webp",
			animationSlide: false,
		});
	});

	[
		...document.querySelectorAll(".mod_carousel_images .glide__slides"),
	].forEach((el, i) => {
		new SimpleLightbox(el.querySelectorAll("a"), {
			overlayOpacity: 0.95,
			className: "mod_carousel_images_lb",
			fileExt: "png|jpg|jpeg|gif|webp",
			animationSlide: false,
		});
	});

	if (document.querySelectorAll(".media-go")) {
		new SimpleLightbox(".media-go", {
			overlayOpacity: 0.95,
			animationSlide: false,
		});
	}

	if (document.querySelectorAll(".media-zoom")) {
		new SimpleLightbox(".media-zoom", {
			overlayOpacity: 0.95,
			animationSlide: false,
		});
	}

	[...document.querySelectorAll("a[href*='#']")].forEach((el, i) => {
		el.addEventListener("click", (e) => {
			let href = e.currentTarget.getAttribute("href"),
				targets = [
					"#popuplantern",
					"#popupprayer",
					"#popupdonation",
					"#popupwedding",
					"#popupwelcome",
					"#popupcontact",
				];
			if (targets.includes(href)) {
				e.preventDefault();
				jQuery(href).foundation("open");
			}
		});
	});

	[...document.querySelectorAll(".video-i .start")].forEach((el, i) => {
		el.addEventListener("click", (e) => {
			let current = e.currentTarget,
				video = prev(current, "video");
			if (video) {
				video.parentElement.classList.add("playing");
				video.setAttribute("controls", "controls");
				video.removeAttribute("muted");
				video.removeAttribute("loop");
				video.play();
			}
		});
	});

	[...document.querySelectorAll(".close-i")].forEach((el, i) => {
		el.addEventListener("click", (e) => {
			let current = e.currentTarget,
				id = current.dataset.close;
			document
				.querySelector('.box_info[data-info="' + id + '"]')
				.classList.add("closed");
		});
	});

	[...document.querySelectorAll(".open-i")].forEach((el, i) => {
		el.addEventListener("click", (e) => {
			let current = e.currentTarget,
				id = current.dataset.open;
			document
				.querySelector('.box_info[data-info="' + id + '"]')
				.classList.remove("closed");
		});
	});

	jQuery(".reveal").on("open.zf.reveal", function (event) {
		document.documentElement.classList.add("is-reveal-open-timed");
	});
	jQuery(".reveal").on("closed.zf.reveal", function (event) {
		document.documentElement.classList.remove("is-reveal-open");
		setTimeout(function () {
			document.documentElement.classList.remove("is-reveal-open-timed");
		}, 600);
	});

	// Loop through each linksList block
	document.querySelectorAll(".linksList").forEach((linksList) => {
		const firstLink = linksList.querySelector("a");

		if (firstLink) {
			const videoHolderId = firstLink.getAttribute("data-videoHolder");
			const videoId = new URL(firstLink.href).searchParams.get("v");

			// Load the first video on page load without autoplay
			loadYouTubeVideo(videoHolderId, videoId, false);

			// Add active class to the first link
			firstLink.classList.add("active");
		}

		// Add click event listeners to links
		linksList.querySelectorAll("a").forEach((link) => {
			link.addEventListener("click", function (e) {
				e.preventDefault();

				const videoHolderId = link.getAttribute("data-videoHolder");
				const videoId = new URL(link.href).searchParams.get("v");

				// Load the clicked video with autoplay
				loadYouTubeVideo(videoHolderId, videoId, true);

				// Remove active class from all sibling links and add to the clicked one
				linksList.querySelectorAll("a").forEach((sibling) => {
					sibling.classList.remove("active");
				});
				link.classList.add("active");
			});
		});
	});

	checkAndUpdateYouTubeIframesLive();

	const textList = document.getElementById("textList");
	if (textList) {
		window.osj.texts = textList ? textList.querySelectorAll("li") : [];
		window.osj.textsLoading = document.getElementById(
			"loadingFloatingText",
		);

		changeText();
	}
});

function checkAndUpdateYouTubeIframesLive() {
	const iframes = document.querySelectorAll(".yt_live_iframe"),
		apiEndpoint = "/wp-json/custom/v1/latest-livestream";

	if (iframes.length === 0) {
		console.log("No YouTube iframe found. Stopping script.");
		return; // Stop execution if no iframes exist
	}

	let lastVideoId = iframes[0].dataset.videoid || null; // Get initial video ID

	function checkLatestVideo() {
		fetch(apiEndpoint) // Fetch latest livestream video data from the API
			.then((response) => response.json())
			.then((data) => {
				if (data.video_id && data.video_id !== lastVideoId) {
					lastVideoId = data.video_id;

					// Update all iframes with the new video ID
					iframes.forEach((iframe) => {
						iframe.src = `https://www.youtube.com/embed/${lastVideoId}?autoplay=1`;
						iframe.dataset.videoid = lastVideoId;
					});

					console.log("Updated iframe to new video:", lastVideoId);
				}
			})
			.catch((error) =>
				console.error("Error fetching latest video:", error),
			);
	}

	// Run check every 60 seconds
	setInterval(checkLatestVideo, 60000);

	// Initial check
	checkLatestVideo();
}

// Function to create the YouTube iframe
function loadYouTubeVideo(videoHolderId, videoId, autoplay) {
	const iframe = document.createElement("iframe");
	iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}&rel=0`;
	iframe.frameBorder = "0";
	iframe.allow = "autoplay; encrypted-media";
	iframe.allowFullscreen = true;

	const videoHolder = document.getElementById(videoHolderId);
	if (videoHolder) {
		videoHolder.innerHTML = ""; // Clear any existing iframe
		videoHolder.appendChild(iframe);
	}
}

function events_calendar() {
	document.addEventListener("DOMContentLoaded", function () {
		let calendarEl = document.getElementById("eventsCalendar");

		if (calendarEl) {
			let alternateItems = next(calendarEl.parentNode, ".calendar_items"),
				alternateItemList = false,
				alternateItemListSet = 0,
				noEventsDiv = false;

			if (alternateItems) {
				(alternateItemList =
					alternateItems.querySelector(".current_items")),
					(noEventsDiv = next(alternateItemList, ".no-events"));
			}

			let calendarOptions = {
				initialView: "dayGridMonth",
				timeZone: osj_vars.timezone,
				events: {
					url: osj_vars.api.events,
					extraParams: {
						cat: calendarEl.dataset.cat,
						getItem: calendarEl.dataset.getitem,
						lang: osj_vars.lang,
					},
					success: function (data) {
						window.osj.calendar.eventsCount = data.length;
						if (data.length == 0 && noEventsDiv) {
							noEventsDiv.style.display = "block";
						}
					},
				},
				fixedWeekCount: false,
				displayEventTime: false,
				selectable: false,
				headerToolbar: false,
				contentHeight: "auto",
				firstDay: 1,
				datesSet: function (arg) {
					document.querySelectorAll(
						"#eventsControls .monthyear",
					)[0].innerHTML = arg.view.getCurrentData().viewTitle;
					if (alternateItems) {
						let alternateTitle =
							alternateItems.querySelector(".current_month");

						if (alternateTitle) {
							alternateTitle.innerHTML =
								arg.view.getCurrentData().viewTitle;
						}

						if (alternateItemList) {
							alternateItemList.innerHTML = "";
							if (noEventsDiv) {
								noEventsDiv.style.display = "none";
							}
						}
					}
					window.osj.calendar.currentEventIds = [];
				},
				eventDidMount: function (info) {
					FullCalendar_add_classes_days_with_events(info.event);

					if (
						!window.osj.calendar.currentEventIds.includes(
							info.event.id,
						)
					) {
						window.osj.calendar.currentEventIds.push(info.event.id);

						new Foundation.Tooltip(jQuery(info.el), {
							tipText: info.event.title,
						});

						if (alternateItemList) {
							if (
								info.event.start.getMonth() + 1 ==
								info.view
									.getCurrentData()
									.viewApi.currentEnd.getUTCMonth()
							) {
								if (info.event.extendedProps.item) {
									alternateItemList.insertAdjacentHTML(
										"beforeend",
										info.event.extendedProps.item,
									);
								}
							} else {
								window.osj.calendar.eventsCount -= 1; // remove count
							}

							if (window.osj.calendar.eventsCount == 0) {
								noEventsDiv.style.display = "block";
							}
						}
					}
				},
				eventClick: function (info) {
					let url = info.event.extendedProps.link;
					if (url != "") {
						window.location.href = url;
					}
				},
				loading: function (isLoading) {
					if (window.calendar) {
						if (isLoading) {
							window.calendar.el.classList.add("loading");
						} else {
							window.calendar.el.classList.remove("loading");
						}
					}
				},
			};

			if (osj_vars.lang == "fr") {
				calendarOptions.locale = "fr";
			}

			window.calendar = new FullCalendar.Calendar(
				calendarEl,
				calendarOptions,
			);

			calendar.render();

			window.calendar.el.classList.add("loading");

			document
				.getElementById("eventMonthNext")
				.addEventListener("click", function () {
					calendar.next();
				});
			document
				.getElementById("eventMonthPrev")
				.addEventListener("click", function () {
					calendar.prev();
				});

			let eventSliderEl = document.getElementById("glide-events");
			if (eventSliderEl) {
				let eventSlider = new Glide(eventSliderEl, {
					type: "slider",
					hoverpause: false,
					keyboard: false,
					perView: 1,
					gap: 20,
					dragDistance: false,
					touchDistance: false,
				}).mount();

				eventSlider.on("run", (direction) => {
					let currentItemIndex = eventSlider.index;
					[
						...document.querySelectorAll("#glide-events .date"),
					].forEach((el, i) => {
						el.classList.remove("active");

						if (i == currentItemIndex) {
							el.classList.add("active");
							calendar.gotoDate(el.dataset.start);
						}
					});
				});
			}
		}
	});
}

function FullCalendar_add_classes_days_with_events(event) {
	let dateStart = event.startStr,
		dateEnd = event.endStr,
		dateRanged = enumerateDaysBetweenDates(dateStart, dateEnd);

	dateRanged.forEach(function (date, index) {
		let day = window.calendar.el.querySelector(
			'.fc-day[data-date="' + date + '"]',
		);

		if (day) {
			day.classList.add("has_event");
			if (event.extendedProps.sameDay == "no") {
				day.classList.add("event-not-sameday");
			}
		}
	});
}

const enumerateDaysBetweenDates = function (startDate, endDate) {
	let dates = [];

	let currDate = dayjs(startDate),
		lastDate = dayjs(endDate),
		days = lastDate.diff(currDate, "days") - 1,
		i = 0;

	dates.push(currDate.format("YYYY-MM-DD"));

	while (i < days) {
		dates.push(currDate.add(i + 1, "days").format("YYYY-MM-DD"));
		i++;
	}

	return dates;
};

const wrap = (elem, tag, className = "") => {
	const div = document.createElement(tag);
	if (Array.isArray(className)) {
		div.classList.add(...className);
	} else {
		div.classList.add(className);
	}
	elem.parentElement.insertBefore(div, elem);
	div.appendChild(elem);
};

const next = function (elem, selector) {
	if (elem == null) return null;
	// Get the next element
	let nextElem = elem.nextElementSibling;

	// If there's no selector, return the next element
	if (!selector) {
		return nextElem;
	}

	// Otherwise, check if the element matches the selector
	if (nextElem && nextElem.matches(selector)) {
		return nextElem;
	}

	// if it's not a match, return null
	return null;
};

const prev = function (elem, selector) {
	if (elem == null) return null;
	// Get the prev element
	let prevElem = elem.previousElementSibling;

	// If there's no selector, return the prev element
	if (!selector) {
		return prevElem;
	}

	// Otherwise, check if the element matches the selector
	if (prevElem && prevElem.matches(selector)) {
		return prevElem;
	}

	// if it's not a match, return null
	return null;
};

const getSiblings = function (e) {
	// for collecting siblings
	let siblings = [];
	// if no parent, return no sibling
	if (!e.parentNode) {
		return siblings;
	}
	// first child of the parent node
	let sibling = e.parentNode.firstChild;

	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

function GlideAutoHeight(Glide, Components, Events) {
	const Component = {
		mount() {
			if (!Glide.settings.autoHeight) return;
			Components.Html.track.style.transition = "height 200ms ease-in-out";
			this.updateTrackHeight();
		},

		updateTrackHeight() {
			if (!Glide.settings.autoHeight) return;

			const activeSlides = Components.Html.slides.filter(
				(slide, index) => {
					return (
						index >= Glide.index &&
						index <= Glide.index - 1 + Glide.settings.perView
					);
				},
			);

			const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
				return Math.max(maxHeight, slide.offsetHeight);
			}, 0);

			const glideTrack = Components.Html.track;
			if (newMaxHeight !== glideTrack.offsetHeight) {
				glideTrack.style.height = `${newMaxHeight}px`;
			}
		},
	};

	Events.on("run", () => {
		Component.updateTrackHeight();
	});
	Events.on("update", () => {
		Component.updateTrackHeight();
	});
	Events.on("resize", () => {
		Component.updateTrackHeight();
	});

	return Component;
}

function changeText() {
	if (
		!textList ||
		window.osj.texts.length === 0 ||
		window.osj.texts.length === 1
	) {
		let index = 0;

		window.osj.textsLoading.classList.toggle("active"); // Show loading before changing text
		window.osj.textsLoading.parentElement.classList.remove("active"); // Show loading before changing text

		window.osj.texts.forEach((li) => {
			li.classList.remove("active");
			li.classList.add("not-active");
		});

		setTimeout(() => {
			window.osj.textsLoading.classList.toggle("active"); // Hide loading
			window.osj.textsLoading.parentElement.classList.add("active"); // Hide loading

			window.osj.texts[window.osj.textListIndex].classList.remove(
				"not-active",
			);
			window.osj.texts[window.osj.textListIndex].classList.add("active");

			window.osj.textListIndex =
				(window.osj.textListIndex + 1) % window.osj.texts.length;
			setTimeout(() => requestAnimationFrame(changeText), 4000);
		}, 2000); // Show loading for 500ms before changing text
	} else if (window.osj.texts.length == 1) {
		let index = 0;

		window.osj.textsLoading.classList.toggle("active"); // Show loading before changing text
		window.osj.textsLoading.parentElement.classList.remove("active"); // Show loading before changing text

		window.osj.texts.forEach((li) => {
			li.classList.remove("active");
			li.classList.add("not-active");
		});

		window.osj.textsLoading.classList.toggle("active"); // Hide loading
		window.osj.textsLoading.parentElement.classList.add("active"); // Hide loading

		window.osj.texts[window.osj.textListIndex].classList.remove(
			"not-active",
		);
		window.osj.texts[window.osj.textListIndex].classList.add("active");

		window.osj.textListIndex =
			(window.osj.textListIndex + 1) % window.osj.texts.length;
	}
}
